import PATH from "constants/path";
import { Top, Apply, Point, Payment, Setting } from "assets/svg";

const LIST_MENU_MOBILE = [
  {
    path: ["/", "/promotions"],
    svg: <Top />,
  },
  {
    path: [PATH.ENTRIES],
    svg: <Apply />,
  },
  {
    path: [PATH.MY_POINT],
    svg: <Point />,
  },
  {
    path: [PATH.PAYMENT],
    svg: <Payment />,
  },
  {
    path: [PATH.SETTING, PATH.MEMBER_INFO, PATH.CHANGE_LOGIN, PATH.CHANGE_EMAIL, PATH.ACCOUNT_INFO, PATH.PASSWORD],
    svg: <Setting />,
  },
];

export { LIST_MENU_MOBILE };
